export default "__VITE_ASSET__BXBUoXQs__"